// extracted by mini-css-extract-plugin
export default {"content":"style_content__4dVg0","leftSide":"style_leftSide__GHfIQ","rightSide":"style_rightSide__pZwLA","type":"style_type__X3eez"};